import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "content"]

  toggleItem(event) {
    const toggle = event.currentTarget
    const toggleIdx = this.toggleTargets.findIndex(x => x === toggle)

    if (toggleIdx === -1) {
      return
    }

    const container = this.contentTargets[toggleIdx]

    container.classList.toggle("hidden")
    toggle.classList.toggle("rotate-90")
  }

  expandAll() {
    this.contentTargets.forEach(content => content.classList.remove("hidden"))
    this.toggleTargets.forEach(toggle => toggle.classList.add("rotate-90"))
  }

  collapseAll() {
    this.contentTargets.forEach(content => content.classList.add("hidden"))
    this.toggleTargets.forEach(toggle => toggle.classList.remove("rotate-90"))
  }
}
